//v616.basics/share_param
var $ = require("jquery");
import config from "../config";
import {Toast} from "vant";
export default{
    /*
    * 获取分享数据
    * */
    getWeixinShanre(url,callbak){
        $.post(config.NEWS_URL + 'v616.basics/share_param',{
            link:url
        }, (res) => {
            //灰色模式
            try{
                if(res.data.grey_model === '5'){
                    var html = document.querySelector('html');
                    html.style['filter'] = 'grayscale(100%)';
                    html.style['-webkit-filter'] = 'grayscale(100%)'
                }
            }catch (e) {

            }
            callbak && callbak(res)
        }, 'JSON')
    },

    zuowenBanner(callbak){
        $.get(config.NEWS_URL+'zuowen.article/getConfigure',(res)=>{
            callbak && callbak(res)
        }, 'JSON')
    },
    CommuntyArticleContent(id,callbak){
        $.get(config.COMMUNTY+'v1/article/read?art_id=' + id,(res)=>{
            callbak && callbak(res)
        }, 'JSON')
    },
    /*
    * 获取文章详情
    *
    * */
    getNewsContent(data,callbak){
        let id = data.id;
        let url = config.NEWS_URL +'v53.article/info.html?id='+id;
        if(data.user_id){
            url = url+"&user_id="+data.user_id
        }
        let shareLink = 'http://img2.yitoutiao.net/t/index.html?id='+id+'#NewsContent&id='+id;
        $.get(url+'&link='+encodeURIComponent(shareLink),(res)=>{
            callbak && callbak(res)
        }, 'JSON')
        //http://news2.yitoutiao.net/v53.article/info.html?id=138546&link=http:%2F%2Fimg2.yitoutiao.net%2F%2Fweb%2Fnews%2Finfo.html%3Fid%3D138546
    },

    /*
    * 获取文章评论
    *
    * */
    getNewsContentReplay(data,callbak){
        let id =data.id ;
        let page = data.page
        let url = config.NEWS_URL +'V53.article/discuss?id='+id +'&page='+page;
        if(data.user_id){
            url = url+"&user_id="+data.user_id
        }
        $.get(url,(res)=>{
            callbak && callbak(res)
        }, 'JSON');
    },
    /*
    * 获取文章图文直播
    *
    * */
    getArticleImg_live_lists(art_id, page, callBack) {
        let url = config.NEWS_URL + 'v43.article/live_lists?art_id=' + art_id + '&page=' + page;
        $.get(url,(res)=>{
            callBack && callBack(res)
        }, 'JSON');
    },

    /*
    * 获取AI视频配置
    * */
    get_ai_option(class_id,callBack){
        let url = config.NEWS_URL + '/v616.ai/get_ai_option?class_id=' + class_id ;
        $.get(url,(res)=>{
            callBack && callBack(res)
        }, 'JSON');
    },
    /*
    * 获取AI视频列表
    * */
    get_ai_list(data,callBack){
        let url = config.NEWS_URL + '/v616.ai/get_ai_list?keywords='+data.keywords+'&class_id='+data.id ;
        $.get(url,(res)=>{
            callBack && callBack(res)
        }, 'JSON');
    },
    /*
    * 获取AI视频标签
    * */
    get_ai_category(id,callBack){
        let url = config.NEWS_URL + '/v616.ai/get_ai_category?class_id='+id ;
        $.get(url,(res)=>{
            callBack && callBack(res)
        }, 'JSON');
    },
    preserve_board(data,callbak){
        $.post(config.NEWS_URL + '/v616.ai/preserve_board',{
            content:data.content,
            class_id:data.id
        }, (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },
    get_board(id,callbak){
        let url = config.NEWS_URL + '/v616.ai/get_board?class_id='+id ;
        $.get(url,(res)=>{
            callbak && callbak(res)
        }, 'JSON');
    },
    /*
    * 统计
    * */
    data_statistics(data,callbak){
        $.post(config.NEWS_URL + '/v616.ai/data_statistics',{
            id:data.id?data.id:'',
            type:data.type?data.type:''
        }, (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },
    /*
    * 专题列表
    * */
    get_zhuanti_lists(art_id, page, callBack) {
        let url = config.NEWS_URL + 'v616.article/special_list?from=web&labels_id=&page=' + page + '&specsub_id='+art_id;
        $.get(url,(res)=>{
            callBack && callBack(res)
        }, 'JSON');
    },
    /*
   * 专栏列表
   * */
    get_zhuanlan_lists(art_id, page, callBack) {
        let url = config.NEWS_URL + 'v53.article/lists?from=web&spec_id=' + art_id + '&page=' + page;
        $.get(url,(res)=>{
            callBack && callBack(res)
        }, 'JSON');
    },
    /*
    * 获取文章详情
    *
    * */
    scrollAdContent(id,callbak){
        let url = config.NEWS_URL +'v53.article/info.html?from=web&id='+id;
        $.get(url,(res)=>{
            callbak && callbak(res)
        }, 'JSON')
        //http://news2.yitoutiao.net/v53.article/info.html?id=138546&link=http:%2F%2Fimg2.yitoutiao.net%2F%2Fweb%2Fnews%2Finfo.html%3Fid%3D138546
    },

    /*
    * 作文分类列表
    *
    * */
    zw_class_list: function( callBack) {
        let url = config.NEWS_URL +'zuowen.article/class_list';

        $.get(url,(res)=>{
            callBack && callBack(res)
        }, 'JSON')

    },
    /*
   * 作文投稿
   *
   * */
    zw_tougao: function(data,callBack) {
        let url = config.NEWS_URL +'zuowen.article/set_contribution';
        $.post(url,data,function(res){
            callBack && callBack(res)
        })

    },
    zw_dianpin_list(id,callBack){
        let url = config.NEWS_URL +'zuowen.article/replay_list?art_id='+id;

        $.get(url,(res)=>{
            callBack && callBack(res)
        }, 'JSON')
    },

    /*
   * 名家点评 评论列表
   *
   * */
    zw_expert_comment_list: function( id,page,callbak) {
        let url = config.NEWS_URL + 'zuowen.Expertlist/expert_comment_list?limit=10&ze_id='+id+"&page="+page;
        $.get(url,(res)=>{
            callbak && callbak(res)
        }, 'JSON');

    },

    /*
   * 名家点评详情
   *
   * */
    mjdp_contentt: function( id,callbak) {
        let url = config.NEWS_URL + '/zuowen.expertlist/expert_details?ze_id='+id;
        $.get(url,(res)=>{
            callbak && callbak(res)
        }, 'JSON');

    },

    uploadFile:function(data,callbak){
        let url = config.USER_URL + '/publicimg/upload_file';
        $.ajax({
            method:'POST',
            url:url,
            data:data,
            cache:false,
            // 不对FromData中的url进行编码，原样发送
            processData:false,
            // 不修改contentType属性，使用默认
            contentType:false,
            dataType: "json",
            mimeType: "multipart/form-data",
            success: function(res) {
                callbak && callbak(res)
            }
        })

    },
    /*
* 获取验证码
* */
    getSmsCode(phone,callback){

        $.post(config.USER_URL + 'check220.send/sms',{
            phone:phone
        }, (res) => {
            callback && callback(res)
        }, 'JSON')
    },


    login:function(data,callbak){
        let url = config.USER_URL + '/three2313.login/index';
        $.post(url,data, (res) => {
            callbak && callbak(res)
        }, 'JSON')



    },
    /*
    * 获取验证码
    * */
    getSmsCode2(phone,callback){

        $.post(config.USER_URL + '/three2313.send/sms',{
            phone:phone
        }, (res) => {
            callback && callback(res)
        }, 'JSON')
    },



    /*
    * 获取积分
    * 类别： 1-打开APP，2-登录 3-文章阅读 4-视听音频 5-视听视频 6-留言文章 7-留言视频
    *  8-留言直播 9-“问神鸟”提问 10-分享 11-爆料，12-点赞 13-评论，14-推荐下载
    * */
    get_integral: function get_integral(data, callBack) {
        if (!data.id) {
            data.id = '';
        }

        let url = config.USER_URL + '/three2313.video/set_points?type=5&object_id='+data.id;

        $.ajax({
            url:url,
            headers: {
                token: data.token
            },
            type: "get",
            dataType:"JSON",
            success: (data)=>{
                callBack && callBack(data)
            }
        });

    },
    /*
    * 看视频得积分视频详情
    * */
    jifenvideoContent(data,callback){
        let url = config.USER_URL + '/three2313.video/info&id='+data.id;
        $.ajax({
            url:url,
            headers: {
                token: data.token
            },
            type: "get",
            dataType:"JSON",
            success: (data)=>{
                callback && callback(data)
            }
        });

    },

    /*
    * 看视频得积分视频列表
    * */
    jifenvideolist(data,callback){
        let url = config.USER_URL + '/three2313.video/lists';
        $.ajax({
            url:url,
            headers: {
                token: data.token
            },
            type: "get",
            dataType:"JSON",
            success: (data)=>{
                callback && callback(data)
            }
        });

    },

    h5_login:function(data,callbak){
        let url = config.USER_URL + '/h5.login/index';
        $.post(url,data, (res) => {
            callbak && callbak(res)
        }, 'JSON')



    },
    h5_register:function(data,callbak){
        let url = config.USER_URL + '/h5.register/index';
        $.post(url,data, (res) => {
            callbak && callbak(res)
        }, 'JSON')



    },

    h5_praise:function(data,token,callbak){


        let url = config.USER_URL + '/h5.article/praise';
        $.ajax({
            url:url,
            headers: {
                token: token
            },
            data:data,
            type: "POST",
            success: function (data) {
                callbak && callbak(data)
            }
        });
    },



    /*
   * 获取验证码
   * */
    getWebLoginSms(data,callback){

        $.post(config.USER_URL + '/h5.send/sms',data, (res) => {
            callback && callback(res)
        }, 'JSON')
    },
    check_token:function(token,callbak){
        let url = config.USER_URL + '/h5.login/check_token';
        $.ajax({
            url:url,
            headers: {
                token: token
            },
            type: "get",
            success: function (data) {
                callbak && callbak(data)
            }
        });

    },
    replayNews(token,data,callbak){
        let url = config.USER_URL + '/h5.article/comment';
        $.ajax({
            url:url,
            headers: {
                token: token
            },
            data:data,
            type: "POST",
            success: function (data) {
                callbak && callbak(data)
            }
        });
    },

    //

    lanmu_list(data,callbak){
        $.post(config.VIDEO2_URL + '/v80.tv/tv_lists',data, (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },
    /*
    * 栏目详情
    * */
    lanmu_content(data,callbak){
        $.post(config.VIDEO2_URL + '/v80.tv/catalog',data, (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },
    getVideo(videoId, callbak){

        $.get(config.VIDEO2_URL + '/public_video/index?videoId=' + videoId, (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },

    /*
    * 视频号视频详情
    * */
    movie_numbers_info(data,callbak){
        $.post(config.VIDEO2_URL + '/v80.tv/getMovieNumbersInfo',data, (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },
    getVideoReplayList(id, callbak){

        $.get(config.VIDEO2_URL + 'V53.comment/lists?movie_id=' + id+'&page=1', (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },
    getVideoReplayList2(id, callbak){

        $.get(config.VIDEO2_URL + '/v80.tv/getMovieNumberArticleCommentlists?mn_article_id=' + id+'&page=1', (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },
    //视频号个人中心
    movie_numbers_personal(data,callbak){
        $.post(config.VIDEO2_URL + '/v80.tv/getMovieNumbersPersonal',data, (res) => {
            callbak && callbak(res)
        }, 'JSON')

    },
//获取视频详情
    getVideoInfo(id,callbak){
        $.get(config.VIDEO2_URL + '/movie/minfo.html?id='+id, (res) => {
            callbak && callbak(res)
        }, 'JSON')

    },
    getLiveVideoInfo(id,callbak){
        $.get(config.USER_URL + '/share/lived?id='+id, (res) => {
            callbak && callbak(res)
        }, 'JSON')

    },
    hot_required(callbak){
        $.post(config.NEWS_URL + '/v80.article/hot_required?from=web', (res) => {
            callbak && callbak(res)
        }, 'JSON')
    },


    //获取成视视频列表
    getCengshiList:function(data, callBack){
        var url = config.VIDEO2_URL + '/v1107.video/chengshi_list';
        $.post(url ,data, (res) => {
            callBack && callBack(res)
        }, 'JSON')



    },

    /*
    * 获取作文榜单
    *
    * */
    zwRank(id,callbak){
        let url = config.NEWS_URL +'zuowen.article/get_zuowen_huodong_lists?page=1&limit=1000&ac_id='+id;
        $.get(url,(res)=>{
            callbak && callbak(res)
        }, 'JSON')
        //http://news2.yitoutiao.net/v53.article/info.html?id=138546&link=http:%2F%2Fimg2.yitoutiao.net%2F%2Fweb%2Fnews%2Finfo.html%3Fid%3D138546
    },

}
